import script from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardHeader.vue?vue&type=style&index=0&id=5ae4bfaa&lang=css"

const __exports__ = script;

export default __exports__